import moment from 'moment';
import http from '~/http/new';

export default ({
  state: {
    data: [],
    filters: {},
    sort: {
      sort: 'defaultSort',
      sortDesc: false,
    },
    page: 1,
    pages: 0,
    filterLists: {
      arrayList: [
        { id: 0, caption: 'Caption' },
      ],
    },
  },

  getters: {
    requestData(state, _getters, _rootState, rootGetters) {
      const { filters, sort, page } = state;
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      return {
        ...filters,
        ...sort,
        offset: (page - 1) * itemsPerPage,
        dateFrom: filters.dateFrom ? moment.utc(filters.dateFrom).unix() : undefined,
        dateTo: filters.dateTo ? moment.utc(filters.dateTo).set({ hour: 23, minute: 59, second: 59 }).unix() : undefined,
        limit: itemsPerPage,
        getTotal: true,
      };
    },
  },

  mutations: {
    SET_FILTERS(state, data) { state.filters = data; },
    SET_PAGE(state, value) { state.page = value; },
    SET_PAGES(state, value) { state.pages = value; },

    SET_DATA(state, data) {
      state.data = data;
    },
  },

  actions: {
    setFilters({ commit }, data) { commit('SET_FILTERS', data); },
    setPage({ commit }, value) { commit('SET_PAGE', value); },
    setPages({ commit }, value) { commit('SET_PAGES', value); },

    async loadData({ getters, commit, rootGetters }, data) {
      const itemsPerPage = rootGetters['common/itemsPerPage'];
      const response = await http.get('v1/devices/search', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      const { items, total } = response.data;
      commit('SET_DATA', items);
      if (total) {
        const pages = Math.ceil(total / itemsPerPage);
        commit('SET_PAGES', pages);
      }
      return response.data;
    },

    async searching({ getters }, data) {
      const response = await http.get('v1/devices/search', {
        params: {
          ...getters.requestData,
          ...data,
        },
      });
      return response.data;
    },

    async loadDataLazy({ state, dispatch }, data) {
      if (state.data.length) return;
      await dispatch('loadData', data);
    },

    async deleteDevice(__store, id) {
      const { data } = await http.delete(`v1/devices/${id}`);
      if (!data?.result?.Success) {
        throw new Error(`The device has not been removed because of Error: "${data?.result?.Error}"`);
      }
      return data;
    },
  },

  namespaced: true,
});
